import React from 'react';
import { useTranslation } from 'react-i18next';
import './LimitExceededModal.css'; // Reuse existing modal styles

function DeleteConfirmationModal({ isOpen, onConfirm, onCancel }) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>{t('deleteModal.title')}</h2>
        <p>{t('deleteModal.confirm')}</p>
        <div className="modal-buttons">
          <button className="modal-button secondary" onClick={onCancel}>
            {t('deleteModal.cancel')}
          </button>
          <button className="modal-button primary" onClick={onConfirm}>
            {t('deleteModal.delete')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmationModal;